import { SerializedError } from "@reduxjs/toolkit";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query/react";

export const getErrorMessage = (
  error: FetchBaseQueryError | SerializedError
): string => {
  if (
    "data" in error &&
    error.data &&
    typeof error.data === "object" &&
    "title" in error.data
  ) {
    return String(error.data.title);
  }

  if ("message" in error && error.message) {
    return error.message;
  }
  return "Произошла неизвестная ошибка";
};
